import Papa from "papaparse";

/**
 * @param url, filepath of csv data file
 * @returns {content} content in the form of a JavaScript two dimensional array
 */
export function getData(url){
    let xmlhttp = new XMLHttpRequest();
    xmlhttp.open("GET", url,false);
    xmlhttp.send();
    let content = xmlhttp.responseText;
    return parseCSV(content);
}

export function parseCSV(content) {
    const parsed = Papa.parse(content, {dynamicTyping: true, skipEmptyLines: true});
    const data = parsed.data;
    // Remove header
    data.shift();
    return data;
}

